const CallPointPushButtonIcon = ({ strokeColor = '#808080' }) => {
  return (
    <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 795.1 795.1">
      <g id="Circles">
        <circle id="Grey_Bkg" data-name="Grey Bkg" cx="397.55" cy="397.55" r="388.66" fill="#4d4d4d" />
        <circle 
          id="Grey" 
          cx="397.55" 
          cy="397.55" 
          r="372.55" 
          fill="none" 
          stroke={strokeColor} 
          strokeWidth="50px" 
          strokeMiterlimit="10" 
        />
        <circle 
          id="White_Inner" 
          data-name="White Inner" 
          cx="397.55" 
          cy="397.55" 
          r="343.4" 
          fill="none" 
          stroke="#fff" 
          strokeWidth="20px" 
          strokeMiterlimit="10" 
        />
      </g>
      <g id="Shapes">
        <g id="Layer_1-2" data-name="Layer 1-2">
          <path 
            fill="#fcfcfc" 
            d="M556.44,330.74c0-31.97,0-63.2.02-94.44,0-12.49-2.18-14.76-14.38-14.76H252.13c-11.45,0-13.51,2.11-13.51,13.8,0,96.65,0,193.3,0,289.95,0,11.25,2.32,13.51,13.8,13.51h65.67v21.72c-1.66.13-3.52.41-5.38.41-20.66.03-41.32.08-61.97,0-21.27-.08-34.26-13.13-34.26-34.29,0-98.62,0-197.23,0-295.85,0-19.28,12.24-31.38,31.74-31.38,99.36,0,198.71,0,298.06,0,20.12,0,32.21,11.51,32.24,31.65.14,99.84.14,199.69,0,299.54-.03,20.84-16.3,32.84-39.62,29.67v-20.41c.34-.28.68-.79,1.05-.82,15.97-1.09,16.53-1.74,16.53-17.95-.03-63.2-.03-126.4-.05-190.34h0Z"
          />
          <path 
            fill="#fcfcfc" 
            d="M361.22,387.11c-14.12,21.41-10.22,47.94,9.49,65.85.69-8.5.48-17.07,2.27-25.2,2.79-12.74,14.28-19.98,27.64-18.82,11.26.98,21.96,11.53,22.36,23.46.55,16.17.14,32.38.14,49.47,10.66-1.8,19.58-.86,23.77,9.82,17.52-10.03,24.26-9.5,33.97.94,8.01,0,14.9-1.27,21.09.27,12.2,3.03,18.52,14.84,19.83,31.85,2.48,32.19-3.28,63.29-12.14,93.93-1.02,3.51-5.89,7.4-9.66,8.33-8.87,2.19-13.93-4.74-11.65-14.82,1.92-8.51,3.59-17.11,6.08-25.46,6.51-21.91,3.4-44.32,3.88-66.53.11-5.06-2.81-6.52-7.31-4.15-13.78,7.25-19.8,3.66-27.44-8.45-1.51,1.12-3.09,2.1-4.45,3.33-9.23,8.41-19.05,7.91-26.29-2.04-2.61-3.58-4.58-4.54-8.95-3.24-8.22,2.44-15.99-1.23-19.2-9.21-2.04-5.09-3.33-10.78-3.54-16.25-.5-13.26.06-26.56-.32-39.83-.09-3.12-2.2-6.19-3.38-9.28-1.27,2.99-3.63,5.98-3.65,8.98-.27,31.47-.3,62.95-.06,94.42.05,6.14-1.63,11.13-7.42,12.8-6.25,1.81-11.03-.93-14.27-7.14-1.78-3.42-5.5-5.83-9.05-8.1-2,20.52-3.61,40.17,8.06,58.11,4.21,6.47,7.01,13.89,10.22,20.99,3.07,6.81,1.1,12.48-4.94,15.26-6.23,2.87-12.04.91-15.11-5.75-7.19-15.6-16.38-30.77-20.42-47.18-3.53-14.35-2.62-30.33-.93-45.28,1.65-14.51,13.13-20.26,31.59-18.71,0-8.81.32-17.6-.22-26.34-.14-2.26-2.59-4.9-4.66-6.44-16.94-12.62-30.2-27.85-34.94-49.03-8-35.75,12.93-70.59,48.28-80.73,38.33-10.99,79.07,13.78,85.57,53.05,3.73,22.54-3.83,42.31-19.5,58.91-9.31-4.32-12.2-12.06-7.45-20.55,19.59-35-10.04-73.69-43.12-70.75-14.17,1.26-25.53,7.46-34.15,19.5h0Z"
          />
          <path 
            fill="#fbfbfc" 
            d="M444.95,321.71c-33.16-.02-65.61-.02-98.07-.03-11.79,0-16.03-4.17-16.07-15.79-.04-12.29-.13-24.59-.07-36.88.05-11.47,3.6-15,14.79-15.01,35.16,0,70.32,0,105.48,0,9.55,0,13.36,3.76,13.38,13.17.03,12.05,0,24.1,0,36.14,0,14.84-3.67,18.45-19.44,18.39M416.43,299.75h25.37v-22.85h-88.04v22.85h62.67,0Z"
          />
        </g>
      </g>
    </svg>
  );
};

export default CallPointPushButtonIcon;